export default __webpack_public_path__ + "static/media/questions.633866b8.png";